import React from 'react';
import { useReducedMotion } from 'framer-motion';
import './TerminalHero.css';

const LINES = [
  { type: 'cmd', text: 'whoami' },
  { type: 'out', text: 'Qazi Absaar — AI/ML Engineer · IoT & Embedded Dev' },
  { type: 'cmd', text: 'cat ./currently.txt' },
  { type: 'out', text: '▸ 7th semester BS CS @ PAF-IAST, Haripur' },
  { type: 'out', text: '▸ building autonomous AI agent systems' },
  { type: 'cmd', text: 'uptime' },
  { type: 'out', text: '4+ years building · 15+ projects shipped' }
];

const CMD_SPEED = 55;
const OUT_SPEED = 12;
const LINE_PAUSE = 350;

const TerminalHero = () => {
  const prefersReducedMotion = useReducedMotion();
  const [state, setState] = React.useState({ line: 0, char: 0, done: false });

  React.useEffect(() => {
    if (prefersReducedMotion) {
      setState({ line: LINES.length, char: 0, done: true });
      return;
    }
    if (state.done) return;

    const current = LINES[state.line];
    if (!current) {
      setState((s) => ({ ...s, done: true }));
      return;
    }

    const speed = current.type === 'cmd' ? CMD_SPEED : OUT_SPEED;
    let timer;

    if (state.char < current.text.length) {
      timer = setTimeout(() => {
        setState((s) => ({ ...s, char: s.char + 1 }));
      }, speed);
    } else {
      timer = setTimeout(() => {
        setState((s) => ({ line: s.line + 1, char: 0 }));
      }, current.type === 'cmd' ? 150 : LINE_PAUSE);
    }

    return () => clearTimeout(timer);
  }, [state, prefersReducedMotion]);

  const typing = !state.done && state.line < LINES.length;
  const visibleCount = typing ? state.line + 1 : LINES.length;

  return (
    <div className="terminal" aria-label="Terminal introduction">
      <div className="terminal-bar">
        <span className="terminal-dot terminal-close" aria-hidden="true" />
        <span className="terminal-dot terminal-minimize" aria-hidden="true" />
        <span className="terminal-dot terminal-maximize" aria-hidden="true" />
        <span className="terminal-title">qazi@dev: ~/portfolio</span>
      </div>
      <div className="terminal-body">
        {LINES.slice(0, visibleCount).map((line, i) => {
          const isActive = typing && i === state.line;
          const text = isActive ? line.text.slice(0, state.char) : line.text;
          const showCursorAfter = isActive || (!typing && i === LINES.length - 1);
          return (
            <div key={i} className={`terminal-line terminal-${line.type}`}>
              {line.type === 'cmd' && (
                <span className="terminal-prompt">
                  qazi@dev<span className="terminal-tilde">:~</span>$
                </span>
              )}
              <span>
                {text}
                {showCursorAfter && <span className="terminal-cursor" aria-hidden="true">▌</span>}
              </span>
            </div>
          );
        })}
        {typing && LINES[state.line].type === 'out' && state.char === 0 && (
          <span className="terminal-cursor" aria-hidden="true">▌</span>
        )}
      </div>
    </div>
  );
};

export default TerminalHero;
